module.exports = __webpack_public_path__ + "app/principal/modals/modal-message-3wXUyHDX.html";